
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter,
  Redirect,
  Switch,
  Route,
  withRouter
} from 'react-router-dom'

import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/MarketingHeader'

import LoginForm from '../../Containers/Authentication/LoginForm'
import SignupForm from '../../Containers/Authentication/SignupForm'
class MarketingPage extends Component {

  render() {
    return (
      <div className='marketing'>
        <Header/> { /*I don't think <Header/> is pulling much in right now */ }

        <header>
          <h1 className="logo left">Huvercraft</h1>
          <div className="auth-actions">
            <a href="/login" className="btn btn-medium btn-primary">Login</a>
            <a href="/signup" className="btn btn-medium btn-secondary">Sign up</a>
          </div>

        </header>

        <section className="hp-hero">
          <div className="hp-hero-content">
            <h2>
              Paperless Fuel Management and Powerful Insights for FBOs
            </h2>

            <a href="/login" className="btn btn-large btn-primary">Get Started</a>
            
          </div>

          <div className="square model-with-device">
            <div className="square-content">
            </div>
          </div>
          
        </section>

        <section className="features-list">
          <div className="feature-item">
            <h4 className="orders">Manage Fuel Orders</h4>
            <p>Paperless management of customer fuel, fluid, and towing orders in a centralized dashboard accessible from any mobile device.</p>    
          </div>
          <div className="feature-item">
            <h4 className="fuel-farm">Fuel Levels</h4>
            <p>Convenient on-demand access to fuel levels of farm tanks and fuel trucks, allowing efficient ordering and filling so shortages don’t occur.</p>    
          </div>
          <div className="feature-item">
            <h4 className="fuel-trucks">Reporting</h4>
            <p>Powerful real-time data to provide fueling usage patterns, customer and employee insights, and specialized custom reports.</p>    
          </div>
          <div className="feature-item">
            <h4 className="reports">Access Anywhere</h4>
            <p>All information is secured using industry standards to provide 24/7 access from any device with internet connectivity.</p>    
          </div>
        </section>

        <section className="call-to-action">
          <h2>Get Started Today!</h2>
          <a href="mailto:support@huvercraft.com" className="btn btn-medium btn-primary">Schedule a Demo</a>
        </section>

        <Footer/>
      </div>
    );
  }
}


// App.contextTypes = {
//   router: React.PropTypes.object
// };

export default MarketingPage




// WEBPACK FOOTER //
// ./src/Containers/Marketing/MarketingPage.js